// modules
import { createStore, applyMiddleware, compose } from 'redux'
import { createEpicMiddleware } from 'redux-observable'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
// epics
import queueEpic from '../logic/queue/queue.effect'
// reducers
import queue from '../logic/queue/queue.reducer'
// helper
import afterRehydrate from '../hooks/afterRehydrate'

/* eslint-disable no-underscore-dangle */
const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ name: 'ws-client' })
    : compose
/* eslint-enable */

const epicMiddleware = createEpicMiddleware()

const persistConfig = {
  key: 'root',
  storage,
  // debug: true,
}

const store = createStore(
  persistReducer(persistConfig, queue),
  composeEnhancers(applyMiddleware(epicMiddleware)),
)

epicMiddleware.run(queueEpic)

// FIXME: pause functionality before rehydration
persistStore(store, null, afterRehydrate)

const { getState, dispatch } = store

export { getState, dispatch }
export default store
